import { StyleSheet } from 'react-native';
import { getBoxShadow } from 'src/helpers/style.helper';
import { ColorTypography } from 'src/theme-v2/color-typography';
import { Neutrals } from 'src/theme-v2/colors';
import { FOCUS_COLOR } from 'src/theme-v2/focus';
import { textLatoStyleDS } from 'src/theme-v2/text';
import { neutrals, brand } from 'src/theme/colors';

export const sharedStyle = StyleSheet.create({
  menuIcon: {
    width: 24,
    height: 24,
    padding: 1,
  },
  buttonActive: {
    backgroundColor: brand.main.variations['lighterWater-3'],
  },
  buttonText: {
    fontWeight: 400,
    fontSize: 16,
    color: neutrals.neutralGrays.ash,
  },
  buttonTextActive: {
    color: brand.main.water,
    fontWeight: 700,
  },
  counter: {
    paddingHorizontal: 7,
    backgroundColor: neutrals.white,
    color: brand.main.water,
    borderRadius: 20,
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 24,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: Neutrals.main.White,
  },
});

export const styleDesktop = StyleSheet.create({
  ...sharedStyle,
  container: {
    flexDirection: 'column',
    height: 572,
  },
  sideMenu: {
    flexDirection: 'row',
    gap: 16,
    paddingVertical: 24,
    borderTopWidth: 1,
    borderColor: neutrals.neutralGrays.dust,
    height: 130,
    justifyContent: 'center',
    alignItems: 'center',
  },
  topMenu: {
    flexDirection: 'row',
    height: 40,
    justifyContent: 'space-between',
    alignItems: 'center',
    alignContent: 'center',
  },
  topMenuInner: {
    flexDirection: 'row',
    gap: 16,
    alignItems: 'center',
    alignContent: 'center',
  },
  wrapper: {
    flex: 1,
    borderRadius: 20,
    borderWidth: 3,
    borderStyle: 'dashed',
    borderColor: brand.main.variations['lighterWater-2'],
    backgroundColor: neutrals.coldGrays.ice,
  },
  wrapperWithoutBorder: {
    flex: 1,
    borderRadius: 20,
  },
  pickerWrapper: {
    flex: 1,
  },
  button: {
    minWidth: 166,
    height: 56,
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'row',
    borderRadius: 16,
    paddingHorizontal: 12,
    paddingVertical: 16,
    gap: 8,
  },
  text: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 21,
    textAlign: 'left',
    color: neutrals.neutralGrays.graphite,
    width: '100%',
    paddingHorizontal: 14,
  },
  sourcesContainer: {
    flexDirection: 'column',
    gap: 8,
  },
  otherChoisesText: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: 26,
  },
  pickerButton: {
    backgroundColor: neutrals.white,
    borderRadius: 50,
    height: 50,
    alignItems: 'center',
    ...getBoxShadow({
      offsetX: 3,
      offsetY: 3,
      blurRadius: 8,
      opacity: 0.1,
      color: neutrals.black,
    }),
    borderWidth: 0,
  },
  pickerButtonTop: {
    backgroundColor: neutrals.white,
    borderRadius: 20,
    height: 40,
    alignItems: 'center',
    ...getBoxShadow({
      offsetX: 3,
      offsetY: 3,
      blurRadius: 8,
      opacity: 0.1,
      color: neutrals.black,
    }),
    justifyContent: 'center',
  },
  pickerButtonHover: {
    backgroundColor: neutrals.coldGrays.pearl,
  },
  textLink: {
    color: brand.main.water,
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 16,
    borderWidth: 0,
    borderColor: brand.main.water,
  },
  header: {
    width: '100%',
    justifyContent: 'center',
    flexDirection: 'row',
    alignItems: 'center',
    paddingBottom: 16,
  },
  left_element: {
    flex: 1,
    alignItems: 'flex-start',
  },
  backIcon: {
    width: 20,
    height: 20,
    color: brand.main.water,
  },
  back: {
    borderWidth: 2,
    borderColor: 'transparent',
  },
  backFocus: { borderColor: FOCUS_COLOR },
  right_element: {
    flex: 1,
    alignItems: 'flex-end',
  },
  center_element: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
  },
  title: {
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 24,
    textAlign: 'center',
  },
  footer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 16,
  },
  footerZoom: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 16,
  },
  buttonFooter: {
    alignItems: 'flex-end',
    flex: 1,
  },
  buttonFooterCentered: {
    justifyContent: 'center',
    width: 200,
  },
  description: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 16,
    textAlign: 'center',
    color: neutrals.neutralGrays.ash,
  },
  closeIcon: { width: 16, height: 16, color: neutrals.neutralGrays.cement },
  wrapperOptions: {
    flex: 1,
    borderRadius: 20,
    borderTopWidth: 1,
    borderTopColor: Neutrals.neutralGreys.GreyNatural100,
    paddingTop: 44,
    gap: 44,
  },
});

export const styleMobile = StyleSheet.create({
  ...sharedStyle,
  containerMobile: {
    width: '100%',
    borderRadius: 0,
    height: '100%',
    maxWidth: 'auto',
    padding: 0,
  },
  container: {
    flexDirection: 'column-reverse',
    justifyContent: 'space-between',
    height: '100%',
  },
  sideMenu: {
    borderTopLeftRadius: 22,
    borderTopRightRadius: 22,
    alignItems: 'center',
    paddingBottom: 24,
    shadowColor: neutrals.black,
    shadowOffset: { width: 0, height: -2 },
    shadowOpacity: 0.12,
    shadowRadius: 8,
    gap: 16,
    position: 'relative',
    zIndex: 2,
  },
  sourcesContainer: {
    flexDirection: 'row',
    gap: 16,
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: 8,
  },
  pickerWrapper: {
    flex: 1,
  },
  optionsWrapper: {
    flex: 1,
  },
  button: {
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 16,
    paddingHorizontal: 16,
    paddingVertical: 4,
    gap: 4,
  },
  header: {
    height: 50,
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 16,
  },
  headertext: {
    ...textLatoStyleDS.TitleBoldLg,
    color: ColorTypography.TextColorPrimary,
  },
  ctaBack: {
    width: 18,
    height: 18,
    justifyContent: 'center',
    position: 'absolute',
    top: 16,
    left: 16,
  },
  ctaBot: {
    justifyContent: 'center',
    position: 'absolute',
    top: 8,
    right: 16,
  },
  pickerButton: {
    backgroundColor: neutrals.white,
    borderRadius: 30,
    height: 38,
    alignItems: 'center',
    ...getBoxShadow({
      offsetX: 3,
      offsetY: 3,
      blurRadius: 8,
      opacity: 0.1,
      color: neutrals.black,
    }),
  },
  pickerInnerButton: {
    flexDirection: 'row',
  },
  description: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 16,
    textAlign: 'center',
    color: neutrals.neutralGrays.ash,
  },
  otherChoisesText: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 19,
  },
  textContainer: {
    flexDirection: 'row',
    width: '100%',
    paddingHorizontal: 24,
  },
  bottomSheet: {
    paddingVertical: 16,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    backgroundColor: Neutrals.main.White,
    gap: 16,
    marginTop: -16,
  },
  imageStyle: { width: '100%', height: '100%' },
  contentContainerStyle: {
    flexGrow: 1,
    justifyContent: 'center',
    gap: 8,
  },
  containerTop: {
    gap: 16,
    paddingHorizontal: 16,
  },
});
